export const LF_WINDOW_MESSAGE = 'lf-message';
